<template>
  <div class="fixed inset-0 z-1000">
    <CockpitDialog
      title="添加人员"
      left="580px"
      width="990px"
      height="650px"
      top="120px"
      @close="visible = false"
    >
      <div class="h-full flex flex-col">
        <div class="flex-auto h-0 overflow-hidden">
          <div class="flex mb-20px mr-10px">
            <el-input
              size="small"
              class="mr-10px !w-50"
              placeholder="请输入人员名称"
              v-model="searchData.userName"
              clearable
            ></el-input>
            <button
              class="handle_btn search mr-10px"
              size="small"
              type="button"
              @click="handleSearch"
            >
              搜索
            </button>
            <button class="handle_btn" size="small" type="button" @click="resetText">
              重置
            </button>
          </div>
          <el-table
            ref="table"
            :data="tableData"
            class="w-full"
            :height="tableHeight"
            v-loading="loading"
            @selection-change="handleSelection"
            :row-key="(row) => row.id"
          >
            <el-table-column
              :reserve-selection="multiple"
              type="selection"
              width="50"
              v-if="multiple"
              :selectable="isDisabled"
            ></el-table-column>
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column
              label="姓名"
              show-overflow-tooltip
              sortable
              prop="name"
            ></el-table-column>
            <el-table-column
              label="账户"
              show-overflow-tooltip
              sortable
              prop="userName"
            ></el-table-column>
            <el-table-column
              label="所属部门"
              width="330px"
              show-overflow-tooltip
              sortable
              prop="orgUnits"
            >
              <template slot-scope="scope">
                <!-- <el-tag
                  class="mx-5px"
                  size="mini"
                  v-for="item in scope.row.orgUnits"
                  :key="item.id"
                  >{{ item.organizationUnitName }}</el-tag
                > -->
                {{ scope.row.orgUnits.map((i) => i.organizationUnitName).join() }}
              </template>
            </el-table-column>
            <el-table-column label="岗位" show-overflow-tooltip sortable prop="posts">
              <template slot-scope="scope">
                <!-- <el-tag class="mx-5px" size="mini" v-for="item in scope.row.posts" :key="item.id">{{
                  item.postName
                }}</el-tag> -->
                {{ scope.row.posts.map((i) => i.postName).join() }}
              </template>
            </el-table-column>
            <el-table-column label="手机号" show-overflow-tooltip prop="phoneNumber">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="baseTableSizeChange"
            @current-change="baseTableCurrentChange"
            :current-page.sync="basePageConfig.SkipCount"
            :page-size.sync="basePageConfig.MaxResultCount"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :total="total"
            class="float-right mt-10px mb-10px ml-10px"
          ></el-pagination>
        </div>
        <!-- <MultiplePersonSelect v-model="personList" placeholder="请选择人员"></MultiplePersonSelect> -->
        <div class="text-center py-10px flex justify-center" v-if="multiple">
          <button class="handle_btn mr-10px" @click="handleOk">
            <span>确定</span>
          </button>
          <button class="handle_btn" @click="visible = false">
            <span>取消</span>
          </button>
        </div>
      </div>
    </CockpitDialog>
  </div>
</template>

<script type="text/babel">
import {
  AccidentEventsResponseRescueDispatchApi,
  DrillsPlanPersonnelApi,
} from '@wiz-api/emergency-management'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
// import MultiplePersonSelect from '@/components/safety/FormSelect/MultiplePersonSelect'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const accidentEventsResponseRescueDispatchApi = new AccidentEventsResponseRescueDispatchApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
const drillsPlanPersonnelApi = new DrillsPlanPersonnelApi()

export default {
  name: 'rescue-scheduling-dialog',
  components: {
    // MultiplePersonSelect,
    CockpitDialog,
  },
  props: {
    // 是否多选
    multiple: {
      type: Boolean,
      default: true,
    },
    dataList: {
      default: [],
    },
  },
  data() {
    return {
      personList: '',

      visible: true,
      tableData: [],
      loading: false,
      total: 0,
      searchData: {},
      basePageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionData: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 100px)'
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  created() {
    this.findList()
  },
  methods: {
    // 禁用复选框
    isDisabled(row) {
      const selection = this.dataList.map((item) => {
        return item.id || item.userId
      })
      if (selection.includes(row.id)) {
        return 0
      }
      return 1
    },
    // 设置选中
    setSelect() {
      this.dataList.forEach((item) => {
        this.$refs.table.toggleRowSelection({ id: item.id })
      })
    },
    // 选中结果事件
    handleSelection(values) {
      this.selectionData = values
    },

    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 搜索 equip 设备设施 base 作业活动
    handleSearch() {
      this.basePageConfig.SkipCount = 1
      this.findList()
    },
    // 页码改变
    baseTableSizeChange(MaxResultCount) {
      this.basePageConfig.MaxResultCount = MaxResultCount
      this.findList()
    },
    // 页数改变
    baseTableCurrentChange(SkipCount) {
      this.basePageConfig.SkipCount = SkipCount
      this.findList()
    },
    // 作业活动列表
    async findList() {
      const data = {
        maxResultCount: this.basePageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.basePageConfig.SkipCount - 1) * this.basePageConfig.MaxResultCount, // 跳过多少条
        includeOrgChild: true,
        ...this.searchData,
      }
      this.loading = true
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
    async handleOk() {
      this.loading = true
      // const [err, res] = accidentEventsResponseRescueDispatchApi.getUserList({
      //   body: this.personList.split(','),
      // })
      const data = this.selectionData.map((item) => {
        return item.id
      })
      if (!data.length) {
        this.visible = false
        return
      }
      const [err, res] = await accidentEventsResponseRescueDispatchApi.getUserList({
        body: {
          userIds: data,
        },
      })
      if (!err) {
        this.$emit('handleOk', res)
        this.visible = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.handle_btn {
  height: 32px;
  width: 96px;
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05bdff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #4dc2d2;
  }
}
.search {
  background: #4dc2d2;
}
.handle_btn[disabled] {
  cursor: no-drop;
}
::v-deep .el-dialog__body {
  padding-bottom: 10px;
}
</style>
